import { render, staticRenderFns } from "./searchFilmCollectionModal.vue?vue&type=template&id=5e1c8bdd&scoped=true&"
import script from "./searchFilmCollectionModal.vue?vue&type=script&lang=js&"
export * from "./searchFilmCollectionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1c8bdd",
  null
  
)

export default component.exports